import { Easing } from "@tweenjs/tween.js"
import React, { ReactNode } from "react"
import { Responsive, TweenEasingFn } from "./types"

/**
 * This component and related files have been copied from https://github.com/femioladeji/react-slideshow and modified
 *
 * See LICENSE file
 */

export const getStartingIndex = (children: ReactNode, defaultIndex?: number): number => {
	if (defaultIndex && defaultIndex < React.Children.count(children)) {
		return defaultIndex
	}
	return 0
}

export const getResponsiveSettings = (wrapperWidth: number, responsive?: Array<Responsive>): Responsive | undefined => {
	if (typeof window !== "undefined" && Array.isArray(responsive)) {
		return responsive.find((each) => each.breakpoint <= wrapperWidth)
	}
	return
}

export enum EasingMethodType {
	Linear = "linear",
	Ease = "ease",
	EaseIn = "ease-in",
	EaseOut = "ease-out",
	Cubic = "cubic",
	CubicIn = "cubic-in",
	CubicOut = "cubic-out",
}

const EASING_METHODS: Record<EasingMethodType, TweenEasingFn> = {
	[EasingMethodType.Linear]: Easing.Linear.None,
	[EasingMethodType.Ease]: Easing.Quadratic.InOut,
	[EasingMethodType.EaseIn]: Easing.Quadratic.In,
	[EasingMethodType.EaseOut]: Easing.Quadratic.Out,
	[EasingMethodType.Cubic]: Easing.Cubic.InOut,
	[EasingMethodType.CubicIn]: Easing.Cubic.In,
	[EasingMethodType.CubicOut]: Easing.Cubic.Out,
}

export const getEasing = (easeMethod?: EasingMethodType): TweenEasingFn => {
	if (easeMethod) {
		return EASING_METHODS[easeMethod]
	}
	return EASING_METHODS.linear
}
